<template>
  <q-btn-dropdown
      flat
      dense
      no-caps
      :label="`${state.selectedLanguage.flag} ${state.selectedLanguage.code.toUpperCase()}`"
      dropdown-icon="keyboard_arrow_down"
      class="language-switcher"
  >
    <q-list>
      <q-item-label header>{{ $t('language.select') }}</q-item-label>

      <q-item
          v-for="lang in availableLocales"
          :key="lang.code"
          clickable
          v-close-popup
          @click="selectLanguage(lang)"
          :class="{ 'bg-primary text-white': state.currentLangCode === lang.code }"
          class="language-item"
      >
        <q-item-section avatar>
          <span class="text-h6">{{ lang.flag }}</span>
        </q-item-section>

        <q-item-section>
          <q-item-label>{{ lang.name }}</q-item-label>
          <q-item-label caption>{{ lang.code.toUpperCase() }}</q-item-label>
        </q-item-section>

        <q-item-section side v-if="state.currentLangCode === lang.code">
          <q-icon name="check" color="positive" />
        </q-item-section>
      </q-item>
    </q-list>
  </q-btn-dropdown>
</template>

<script setup>
import { reactive, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useQuasar } from 'quasar'
import { availableLocales } from '@/i18n'

const { locale } = useI18n()
const $q = useQuasar()

// Реактивное состояние компонента
const state = reactive({
  currentLangCode: locale.value,
  selectedLanguage: availableLocales.find(l => l.code === locale.value) || availableLocales[0]
})

// Выбор языка
const selectLanguage = (selectedLang) => {
  // Обновляем состояние компонента
  state.currentLangCode = selectedLang.code
  state.selectedLanguage = selectedLang

  // Обновляем i18n
  locale.value = selectedLang.code

  // Сохраняем в localStorage
  localStorage.setItem('locale', selectedLang.code)

  // Устанавливаем атрибут документа
  document.documentElement.setAttribute('lang', selectedLang.code)

  // Уведомление
  const messages = {
    'ru': 'Язык изменён на русский',
    'en': 'Language changed to English',
    'uk': 'Мову змінено на українську'
  }

  $q.notify({
    type: 'positive',
    message: messages[selectedLang.code] || messages['en'],
    position: 'top-right',
    timeout: 2000,
    icon: 'language'
  })
}

// Инициализация при монтировании
onMounted(() => {
  const savedLang = localStorage.getItem('locale')
  if (savedLang && availableLocales.find(l => l.code === savedLang)) {
    const langObj = availableLocales.find(l => l.code === savedLang)
    state.currentLangCode = savedLang
    state.selectedLanguage = langObj
    locale.value = savedLang
  }
})
</script>

<style scoped>
.language-switcher {
  min-width: 80px;
}

.language-item.bg-primary {
  border-radius: 4px;
  margin: 2px 8px;
}

.language-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>